import React, { useEffect, useState } from 'react';
import { Modal, Items, Button, Icon, Header, Toast, Message } from 'react-frontier';
import { WorkerPayout, SetLoading } from '../SiteClasses';
import { addCommas } from '../SiteUtil';
import API from '../API';

interface PayoutWorkersModalProps{
	open: boolean;
	onClose: () => void;
	payout_id: number;
	onPaid?: (ids: number[]) => void;
	onUnpaid?: (ids: number[]) => void;
	onCancel?: (ids: number[]) => void;
	paid?: boolean;
	unpaid?: boolean;
	cancel?: boolean;
}

var PayoutWorkersModal = (props: PayoutWorkersModalProps) => {
	var [loadError, setLoadError] = useState<string>(null);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [workers, setWorkers] = useState<WorkerPayout []>(null);
	var [loading, setLoading] = useState<boolean>(false);
	var [selectedWorkers, setSelectedWorkers] = useState<number []>([]);

	useEffect(()=>{
		setLoading(true);
		var condition = props.paid || props.cancel;
		API.getPayoutWorkers(props.payout_id, condition).then(res=>{
			if (res.error) return setLoadError(res.message);
			var filteredWorkers = props.unpaid 
				? res.data.filter((w: WorkerPayout) => w.paid && !w.cancelled)
				: res.data;
			setWorkers(filteredWorkers);
		}).catch(err=>{
			setLoadError('Hubo un error inesperado cargando los trabajadores (LCL-1)');
		}).finally(()=>{
			setLoading(false);
		})
	}, [props.open]);

	var paid = (setLoading: SetLoading)=>{
		if(selectedWorkers.length === 0) return setModalPrompts(['Debes seleccionar al menos un trabajador.']);

		setLoading(true);
		API.paidPayment(props.payout_id, selectedWorkers, true).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Pago realizado!');

			props.onPaid?.(selectedWorkers);
			setSelectedWorkers([])
         props.onClose();
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado realizando el pago. (LCL-1)']);
		}).finally(()=>{	
			setLoading(false);
		})
	}

	var unpaid = (setLoading: SetLoading)=>{
		if(selectedWorkers.length === 0) return setModalPrompts(['Debes seleccionar al menos un trabajador.']);
		
		setLoading(true);
		API.paidPayment(props.payout_id, selectedWorkers, false).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Pagos marcados como no pagados!');

			props.onUnpaid?.(selectedWorkers);
			setSelectedWorkers([])
         props.onClose();
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado marcando los pagos como no pagados. (LCL-2)']);
		}).finally(()=>{	
			setLoading(false);
		})
	}

	var cancel = (setLoading: SetLoading)=>{
		setLoading(true);
		API.cancelPayment(props.payout_id, selectedWorkers).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Pago cancelado!');

			props.onCancel?.(selectedWorkers);
			setSelectedWorkers([])
         props.onClose();
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado cancelando el pago. (LCL-1)']);
		}).finally(()=>{	
			setLoading(false);
		})
	}
	
	return <Modal open={props.open} size='tiny'>
		<Modal.Header>{props.paid ? 'Realizar pagos' : props.unpaid ? 'Marcar no pagados' : 'Cancelar pagos'}</Modal.Header>
		{loading || !workers ? <Header text={'Cargando datos'} loading /> : workers.length !== 0 ? <Modal.Content>
			<div style={{ textAlign: 'center', padding: 5 }}> 
				<Button text='Seleccionar todos' color='black' onClick={() => {
					if(selectedWorkers.length === workers.length){
						setSelectedWorkers([]);
					}else{
						setSelectedWorkers(workers.map(w => w.worker_id));
			}}}/>
			</div>
			<Items
				style={{ overflow: 'auto', maxHeight: 300, overflowY: 'scroll' }}
				toggle
				selectable
				data={workers}
				selected={selectedWorkers}
				onToggle={setSelectedWorkers}
				valueExtractor={w=>w.worker_id}
				render={w=>{
					return <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
						<Icon name='user'/>
						<div style={{ width: '50%'}}>
							<div style={{ fontSize: 14, fontWeight: 'bold'}}>{w.worker_name}</div>
							<div style={{ fontSize: 12, color: 'gray' }}>{w.title_name || 'Otro'}</div>
						</div>
						<div style={{ width: '50%' , textAlign:'end'}}>
							<div style={{ fontSize: 14, fontWeight: 'bold'}}>${addCommas(w.amount)}</div>
						</div>
					</div>
				}}
			/>
			<Message type="error" list={modalPrompts} />
		</Modal.Content> : <Header text={'No se encontraron registros.'} />}
		<Modal.Actions>
			<Button text='Cerrar' basic onClick={props.onClose}/>
			{!props.cancel ? (
				<Button text='Guardar' color='black' onClick={props.paid ?  paid : unpaid}/>
			) : (
				<Button text='Cancelar' color='red' basic onClick={cancel}/>
			)}
		</Modal.Actions>
	</Modal>
}

export default PayoutWorkersModal;
